// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectMarginCallMessage } from "../../../../Utils/DirectMessages/DirectMarginCallMessage.js"
import { generateReportMessageHandler } from "../../../../Utils/AppHandlers.js"

export let MarginCallMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}

MarginCallMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

MarginCallMessageProcessor.prototype.decode = function (fieldSet)
{
    let msg = new DirectMarginCallMessage();
    let factory = FieldsFactory;

    msg.UserId = fieldSet.GetValue(factory.FIELD_ACCOUNT_ID);
    msg.AssetId = fieldSet.GetValue(factory.FIELD_ASSET_ID);
    msg.StopOutType = fieldSet.GetValue(factory.FIELD_STOPOUT_TYPE);
    msg.Balance = fieldSet.GetValue(factory.FIELD_BALANCE);
    msg.UsedMargin = fieldSet.GetValue(factory.FIELD_USED_MARGIN);
    msg.IsMarginCall = fieldSet.GetValue(factory.FIELD_IS_MARGINCALL);

    return [generateReportMessageHandler.GenerateReportMessage(msg)]; //[msg];
}